import { ImagePlus } from "lucide-react";

function Image({ src }) {
  return src ? <img src={src} alt="option" style={{ width: 50, height: 50 }} /> : <ImagePlus size={50} />
}

function Content({ imagePosition, src, answer }) {
  return <div className={`flex justify-center items-center ${imagePosition === 'top' || imagePosition === 'bottom' ? 'flex-col' : ''}`}>
    {(imagePosition === 'left' || imagePosition === 'top') && <Image src={src} />}
    {answer}
    {(imagePosition === 'right' || imagePosition === 'bottom') && <Image src={src} />}
  </div>
}

const getStyle = answer => {
  const style = {}

  if (answer.backgroundColor) style.backgroundColor = `rgba(${answer.backgroundColor})`
  if (answer.fontColor) style.color = `rgba(${answer.fontColor})`
  if (answer.padding) style.padding = answer.padding
  if (answer.fontSize) style.fontSize = `${answer.fontSize}`
  if (answer.borderSize) style.borderWidth = `${answer.borderSize}`
  if (answer.borderStyle) style.borderStyle = answer.borderStyle
  if (answer.borderColor) style.borderColor = `rgba(${answer.borderColor})`

  return style
}

export default function Option({ answer, buttonPadding, onClick }) {
  const { imagePosition = 'top' } = answer
  const styles = getStyle(answer)

  return <div className={`border twy-border-base flex justify-center items-center flex-col cursor-pointer ${buttonPadding ? `p-${buttonPadding}` : ''}`} style={styles} onClick={() => onClick(answer.index)}>
    <Content imagePosition={imagePosition} answer={answer.answer} src={answer.src} />
  </div>
}
